import React from "react";
import "./Projects.css";

const projectCategories = [
  {
    title: "Websites",
    description:
      "Corporate websites, landing pages, and marketing sites built for performance, credibility, and stronger digital branding.",
    tags: ["Corporate", "Landing Pages", "SEO"],
  },
  {
    title: "Web Applications",
    description:
      "Custom web platforms, portals, and dashboards designed to support operations, workflows, and business automation.",
    tags: ["Dashboards", "Portals", "Admin Systems"],
  },
  {
    title: "Mobile Applications",
    description:
      "Cross-platform mobile applications developed for Android, iOS, and enterprise use with scalable real-world functionality.",
    tags: ["Flutter", "Android", "iOS"],
  },
  {
    title: "Digital Signage Systems",
    description:
      "Centralised digital signage platforms for remote monitoring, scheduling, media control, and operational visibility.",
    tags: ["GridSync", "CMS", "Monitoring"],
  },
  {
    title: "Cloud & Infrastructure",
    description:
      "Scalable cloud architecture, deployment pipelines, hosting environments, and infrastructure management for reliable delivery.",
    tags: ["AWS", "DevOps", "CI/CD"],
  },
  {
    title: "IoT & Automation",
    description:
      "Integrated hardware and software solutions that enable automation, device communication, monitoring, and smart workflows.",
    tags: ["IoT", "Automation", "Integrations"],
  },
];

export default function Projects() {
  return (
    <div className="projects-page">
      <div className="projects-container">
        <div className="projects-header">
          <span className="projects-eyebrow">Project categories</span>

          <h1 className="projects-title">
            Solutions across <span>platforms</span> and industries
          </h1>

          <p className="projects-intro">
            A showcase of project categories delivered across web, mobile,
            cloud, IoT, and digital operations. Each solution is built with a
            focus on performance, maintainability, and long-term business value.
          </p>
        </div>

        <div className="projects-grid">
          {projectCategories.map((item, index) => (
            <div key={index} className="project-card">
              <div className="project-card-top">
                <div className="project-icon-wrap">
                  <div className="project-icon-dot"></div>
                </div>
              </div>

              <h3>{item.title}</h3>
              <p>{item.description}</p>

              <div className="project-tags">
                {item.tags.map((tag, i) => (
                  <span key={i}>{tag}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}